export type {
  VideoConsultCreateRoomRequest,
  VideoConsultCreateRoomResponse,
  VideoConsultInvitationType,
  VideoConsultSendInvitationRequest,
  VideoConsultSendInvitationResponse,
} from './schema';

export {
  VideoConsultCreateRoomRequestSchema,
  VideoConsultCreateRoomResponseSchema,
  VideoConsultSendInvitationRequestSchema,
  VideoConsultSendInvitationResponseSchema,
} from './schema';
